import { AlphaHIcon } from './AlphaHIcon';

/**
 * author: GreenTurtwig
 * id 99A5A78F-6759-4C02-A5D2-DA8FA3DDBBA9
 * name alpha-h
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-h.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterHIcon = AlphaHIcon;
export default LetterHIcon